import React from 'react';
import PuptasticApp from './PuptasticApp';

function App() {
  return (
    <div className="App">
      <PuptasticApp />
    </div>
  );
}

export default App;
